export function getRandomPositiveInt(max: number) {
  return Math.floor(Math.random() * max);
}
